module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/delivery_delayed-79bb92b7e4e6310832d8706c4b331e66.png";